import { render, staticRenderFns } from "./FaqMaster.vue?vue&type=template&id=a6c14a04&scoped=true&"
import script from "./FaqMaster.vue?vue&type=script&lang=js&"
export * from "./FaqMaster.vue?vue&type=script&lang=js&"
import style0 from "./FaqMaster.vue?vue&type=style&index=0&id=a6c14a04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c14a04",
  null
  
)

export default component.exports